interface buttonProps {
  label: string;
  onClick: any;
}

const HallowButton: React.FC<buttonProps> = ({ label, onClick }) => {
  return (
    <button
      onClick={onClick}
      className="border-2 h-fit border-primary px-4 text-primary rounded-md "
    >
      {label}
    </button>
  );
};

export default HallowButton;
